var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
/**
 * One treatment the practice offers for a new non-GKV episode (PRD #1343,
 * RS-008), as the patient booking flow renders it. A strictly redacted
 * projection of the treatment catalog: only the concept id (the public service
 * id the slot search and the intake payload reference), the display name and
 * the Heilmittel abbreviation. Billing internals (billable-service-item ids,
 * prices, payer-domain ids) are deliberately absent — the practice sets pricing
 * when it creates the plan.
 *
 * The abbreviation (e.g. "KG", "MT") is the code a Muster 13 barcode actually
 * prints for a Heilmittel, so the patient-side GKV scan (RS-010) can match a
 * scanned Heilmittel to a concept without a therapist-only catalog search. It is
 * a public display attribute (the practice-side confirm form shows it too), not
 * a billing internal.
 */
export class PatientTreatmentOfferingDto {
    treatmentConceptId;
    name;
    abbreviation;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientTreatmentOfferingDto.prototype, "treatmentConceptId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientTreatmentOfferingDto.prototype, "name", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientTreatmentOfferingDto.prototype, "abbreviation", void 0);
//# sourceMappingURL=patient-treatment-offering.dto.js.map